import GenericService from '@services/GenericService';

class AccountsService extends GenericService {
	constructor() {
		super('accounts');
	}
}

export default AccountsService;
